export default {
  dataModel: {
    types: ['pair:Debate']
  },
  translations: {
    fr: {
      name: 'Discussion |||| Discussions',
      fields: {
        'pair:label': 'Titre',
        'pair:nourishes': 'Chemin',
        'pair:webPage': 'Lien'
      }
    }
  }
};
